import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function CmsPage({ slugOverride }) {
  const { slug: pSlug } = useParams();
  const slug = slugOverride || pSlug;
  const [page, setPage] = useState(null);
  useEffect(() => { api.get(`/cms/${slug}`).then((r) => setPage(r.data)).catch(() => setPage({ title: "Not Found", body: "" })); }, [slug]);
  if (!page) return <div className="container-luxe py-32">Loading…</div>;
  return (
    <div className="container-luxe py-24 max-w-3xl">
      <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight">{page.title}</h1>
      <div className="line-divider my-8" />
      <div className="text-gray-300 whitespace-pre-wrap leading-relaxed">{page.body}</div>
      {slug === "contact" && <ContactForm />}
    </div>
  );
}

function ContactForm() {
  const [f, setF] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/contact", f); toast.success("Message sent"); setF({ name: "", email: "", message: "" }); }
    catch { toast.error("Send failed"); }
    finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="mt-10 glass rounded-2xl p-8 space-y-4">
      <h3 className="font-display text-xl">Send us a message</h3>
      <input data-testid="contact-name" required placeholder="Your name" value={f.name} onChange={(e) => setF({...f, name: e.target.value})} />
      <input data-testid="contact-email" required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({...f, email: e.target.value})} />
      <textarea data-testid="contact-message" required rows={5} placeholder="Message" value={f.message} onChange={(e) => setF({...f, message: e.target.value})} />
      <button data-testid="contact-submit" disabled={busy} className="btn-gold">{busy ? "Sending…" : "Send Message"}</button>
    </form>
  );
}
